
import React, { useEffect, useState, useCallback } from 'react';
import _ from "lodash";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { useTranslation } from "react-i18next";
import "../../../../Localization/i18n";
import i18n from "i18next";
import { useNavigate } from "react-router-dom";
import axios from '../../../../utils/fvAxios';
import TextField from "@mui/material/TextField";
import { Card, Stack, Box } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { ToastContainer, toast } from 'react-toastify';
import apiinfo from "../../../../utils/base-uri.json";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// import { Autocomplete } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Nodata from "../../../Nodata/Nodata";
import { HasPermissions } from '../../../../utils/Token';
import INFO from '../../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../../utils/Enums.json";

import {
    makeStyles,
    TableContainer,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Table,
    withStyles
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        marginTop: theme.spacing(3)
    },
    head: {
        backgroundColor: "#fff",
        minWidth: "100px"
    },
    tableContainer: {
        maxHeight: "700px"
    },
    cell: {
        minWidth: "50px"
    }
}));

const StickyTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#ddd",
        color: theme.palette.common.white,
        left: 0,
        position: "sticky",
        zIndex: theme.zIndex.appBar + 2,

    },
    body: {
        backgroundColor: "#ddd",
        minWidth: "50px",
        left: 0,
        position: "sticky",
        zIndex: theme.zIndex.appBar + 1
    }
}))(TableCell);

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#ddd",
        color: theme.palette.common.black,
    },
    body: {
        fontSize: 10
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    // root: {
    //     "&:nth-of-type(odd)": {
    //         backgroundColor: theme.palette.action.hover
    //     }
    // }
}))(TableRow);


export default function AssignRoles() {

    const classes = useStyles();


    const { t } = useTranslation();
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };



    const [getDetails, setDetails] = useState([]);
    const [orgTypes, setOrgTypes] = useState([]);
    const [orgType, setOrgType] = useState("");

    const [Search, setSearch] = useState("");
    const [searchParam] = useState(["userName"]);

    const [comp, setComp] = useState("");
    const [Companies, setCompanies] = React.useState([]);

    const [compa, setCompa] = React.useState(null);


    const [Id, setId] = React.useState("");
    const [SearchRecordsList, setSearchRecordsList] = React.useState(false);

    function search(data) {
        let Records = data?.filter(s => s?.userName?.includes(Search));
        return Records;


        // return data?.filter((item) => {
        //     return searchParam?.some((newItem) => {
        //         return (
        //             item[newItem].toString().toLowerCase().indexOf(Search.toLowerCase()) > -1
        //         );
        //     });
        // });
    }


    useEffect(() => {
        GetDetailsToAddUser();
    }, []);
    useEffect(() => {
        if (Id)
            UserPermissions();
    }, [Id]);

    useEffect(() => {
        setSearchRecordsList(search(getDetails?.userRoles)?.length == 0 ? true : false);
    }, [Search]);

    const GetDetailsToAddUser = async () => {
        const response = await axios.get("SystemUser/GetDetailsToAddUser");
        setOrgTypes(response?.data?.data?.orgTypes);
    };

    const ChangeRoles = (OId, RId) => {
        const data = _.cloneDeep(getDetails);
        var info = data?.userRoles?.find(x => x?.sysUserOrgId == OId);
        if (info) {
            var index = info?.selectedRoles?.indexOf(RId);
            if (index == -1)
                info?.selectedRoles.push(RId);
            else info?.selectedRoles.splice(index, 1);
        }
        setDetails(data);
    }

    const ChangeOrg = async (e) => {
        setOrgType(e)
        setCompanies([]);
        GetCompanies('', e);
        setId("");
        setCompa(null);
        setDetails([]);

    }
    const GetComp = async (event) => {
        setId(event?.key);
        setCompa(event);
        // const Org = !id ? event?.key : id;
        // setSpinner(!spinner);
        // const res = await axios.get("SystemUser/GetUsersWithPermissions?OrgId=" + Org)
        // setDetails(res?.data?.data);
        // setSpinner(spinner);
        // setComp(res?.data?.status)
    }

    const UserPermissions = async () => {
        setSpinner(!spinner);
        const res = await axios.get("SystemUser/GetUsersWithPermissions?OrgId=" + Id)
        setDetails(res?.data?.data);
        setSpinner(spinner);
        setComp(res?.data?.status)

    }
    const GetCompanies = async (val, org) => {
        var locOrg = org ? org : orgType;
        const response = await axios.get("SystemUser/GetOrganisations?searchValue=" + val + "&orgType=" + locOrg + "&hasPaginationOn=false&&pageSize=30");
        setCompanies(response?.data?.data);

    }


    const SaveRoles = async () => {
        const userRoles = getDetails?.userRoles?.map((r) => {
            return {
                "userName": r?.userName,
                "sysUserOrgId": r?.sysUserOrgId,
                "selectedRoles": r?.selectedRoles
            }
        })
        const obj = {
            "userRoles": userRoles,
            "roles": null
        }
        const res = await axios.post("SystemUser/AssignRoles", obj)
        if (res?.data?.responseCode == 100) {
            toastNotify(res?.data?.responseMessage, true);
            UserPermissions(Id);
        } else {
            toastNotify(res?.data?.responseMessage, false);
        }

    }
    const [spinner, setSpinner] = React.useState(false);
    const SpinnerClose = () => {
        setSpinner(false);
    };

    return (
        <>
            <ToastContainer />

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Card style={{ border: "none" }}>

                <Box sx={{ padding: "20px", "& hr": { mx: 0.5, }, }}>
                    <Stack direction="row" spacing={2}>
                        <div className='mt-3'>
                            <TextField
                                sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                    width: "300px",
                                    height: "40px"
                                }}
                                required
                                type="text"
                                id="Rank"
                                name="Rank"
                                placeholder="Search..."
                                // size="medium"
                                className="form-control text-feild-custom mx-2"
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>


                        <div style={{ marginLeft: "auto" }}>
                            <span className="mx-2">
                                User Organization Type<span className="red-color">*</span>
                            </span>
                            <br />
                            <Select
                                sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                    width: "300px",
                                    height: "40px"
                                }}
                                value={orgType}
                                required
                                // size="medium"
                                placeholder="User Organization Type"
                                name="User Organization Type"
                                id="User Organization Type"
                                className="form-control text-feild-custom mx-2"
                                onChange={(e) => ChangeOrg(e.target.value)}
                            >
                                {orgTypes?.map((r, index) => (
                                    <MenuItem key={index} value={r?.text} sx={{ display: r?.value == -1 ? "none" : "block" }}>
                                        {r.text}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                        <div>
                            <span className="mx-2">
                                Organization<span className="red-color">*</span>
                            </span>
                            <br />

                            <Autocomplete
                                getOptionLabel={(comp) => `${comp?.value}`}
                                value={compa}
                                freeSolo
                                options={Companies}
                                size="small"
                                onChange={(event, value) => GetComp(value)}
                                renderInput={(params) => (
                                    <TextField {...params} sx={{ width: "300px" }} variant="outlined" fullWidth onChange={(e) => GetCompanies(e?.target?.value)} />
                                )}
                            />
                        </div>
                    </Stack>
                </Box>
            </Card>

            <Box sx={{ backgroundColor: '#f8f9fa' }}>
                {getDetails?.userRoles?.length < 1 ? <div hidden={spinner}>
                    <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, marginRight: "12px", width: "auto" }} className="text-center">
                        <span style={{ color: "#667085" }}>No records found, please change your filter criteria</span>
                    </Box>
                </div> :
                    <>
                        {SearchRecordsList == true
                            ?
                            <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, marginRight: "12px", width: "auto" }} className="text-center">
                                <span style={{ color: "#667085" }}>No Records found</span>
                            </Box>
                            : <>
                                <TableContainer className={classes.tableContainer} style={{ display: getDetails == "" || comp == false ? "none" : "block" }}>
                                    <Table stickyHeader aria-label="sticky table" >
                                        <TableHead>
                                            <TableRow>
                                                <StickyTableCell className={classes.head}>
                                                    <StyledTableCell style={{ fontWeight: "bold", fontSize: "12px" }}> User </StyledTableCell>
                                                </StickyTableCell>
                                                {getDetails?.roles?.map((p, i) =>
                                                    <StyledTableCell key={i} style={{ fontWeight: "bold", fontSize: "12px" }}>{p?.roleName}</StyledTableCell>
                                                )}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {search(getDetails?.userRoles)?.map((q, i) => {
                                                return (
                                                    <StyledTableRow key={i}>
                                                        <StickyTableCell >
                                                            {q?.userName}
                                                        </StickyTableCell>
                                                        {getDetails?.roles?.map((r, i) =>
                                                            < StyledTableCell key={i} className='mx-5' >
                                                                <FormControlLabel control={<Checkbox checked={q?.selectedRoles?.find((p) => p == r?.roleId) ? true : false} onChange={(e) => ChangeRoles(q?.sysUserOrgId, r?.roleId)} />} />
                                                            </StyledTableCell>
                                                        )}
                                                    </StyledTableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <div className='text-right mt-3 mb-3'>
                                    {HasPermissions(INFO?.AssignRoles?.actionName, PER?.ScreenPermissions?.Modify) &&
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{ textTransform: "capitalize", padding: "15px", display: getDetails == "" || comp == false ? "none" : "block" }}
                                            onClick={SaveRoles}
                                        >
                                            {t("RolesAdmin.save")}
                                        </Button>
                                    }
                                </div>
                            </>}
                    </>}
            </Box >

        </>

    )
}



